// One reading per minute. When a minute has more than one reading (e.g. every 30 seconds),
// the later, more recent one is used. Charts then group these per-minute readings into
// their chosen interval (5, 15, 30 min...).
export const latestPerMinute = (items) => {
  const byMinute = new Map();
  [...(items || [])]
    .filter((item) => item && item.timestamp)
    .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
    .forEach((item) => {
      const d = new Date(item.timestamp);
      d.setSeconds(0, 0);
      byMinute.set(d.getTime(), item);
    });
  return [...byMinute.values()];
};
